export default {
  recordNotFound: {
    icon: 'fas fa-3x text-warning fa-search',
    title: '404',
    message: 'Este registro não existe ou nunca existiu',
  },
}
